import langFromUrl from 'lib/util/langFromUrl';

const __lang = langFromUrl();

// BAT-4673 Add more information to the aria-label for offer cards
export default function buildAriaLabel(obj) {
  var ariaLabelString = '';
  var isSpanish = __lang === 'es';
  if (obj) {
    if (obj.ribbon.label) {
      ariaLabelString += obj.ribbon.label + '. ';
    }
    if (obj.offerType === 'lease') {
      ariaLabelString += obj.offerType + (isSpanish ? ' TIPO DE OFERTA. ' : ' offer type. ');
      if (isSpanish) {
        ariaLabelString += obj.model.name + '. ';
        ariaLabelString += obj.model.year + '. ';
      } else {
        ariaLabelString += obj.model.year + '. ';
        ariaLabelString += obj.model.name + '. ';
      }
      if (obj.dataLayer.offer_title) {
        ariaLabelString += obj.dataLayer.offer_title + '. ';
      }
      ariaLabelString += '$' + obj.dataLayer.offer_monthly + (isSpanish ? ' AL MES. ' : ' per month. ');
      ariaLabelString += obj.dataLayer.offer_term + (isSpanish ? ' meses. ' : ' months. ');
      ariaLabelString += '$' + obj.dataLayer.offer_amtdue + (isSpanish ? ' A PAGAR AL FIRMAR. ' : ' due at signing. ');
      if (obj.extraCashAmount) {
        // if a lease offer type has an extra cash amount value,
        // mostly likely it's 'cash back', this comes from tda config
        // and not available here, so we have to guess
        ariaLabelString += '$' + obj.extraCashAmount + (isSpanish ? ' reembolso. ' : ' cash back. ');
      }
      ariaLabelString += (isSpanish ? 'expira ' : 'expires ') + obj.dataLayer.offer_expired_date;
    } else if (obj.offerType === 'cash') {
      ariaLabelString += obj.offerType + (isSpanish ? ' TIPO DE OFERTA. ' : ' offer type. ');
      if (isSpanish) {
        ariaLabelString += obj.model.name + '. ';
        ariaLabelString += obj.model.year + '. ';
      } else {
        ariaLabelString += obj.model.year + '. ';
        ariaLabelString += obj.model.name + '. ';
      }
      if (obj.dataLayer.offer_title) {
        ariaLabelString += obj.dataLayer.offer_title + '. ';
      }
      if (obj.dataLayer.offer_cashback) {
        ariaLabelString += '$' + obj.dataLayer.offer_cashback + ' ';
      }
      if (obj.cashTypeLabel) {
        ariaLabelString += obj.cashTypeLabel + '. ';
      }
      if (obj.extraCashAmount) {
        ariaLabelString += '$' + obj.extraCashAmount + ' ';
      }
      if (obj.extraCashLabel) {
        ariaLabelString += obj.extraCashLabel + '. ';
      }
      ariaLabelString += (isSpanish ? 'expira ' : 'expires ') + obj.dataLayer.offer_expired_date;
    } else if (obj.offerType === 'apr') {
      ariaLabelString += obj.offerType + (isSpanish ? ' TIPO DE OFERTA. ' : ' offer type. ');
      if (isSpanish) {
        ariaLabelString += obj.model.name + '. ';
        ariaLabelString += obj.model.year + '. ';
      } else {
        ariaLabelString += obj.model.year + '. ';
        ariaLabelString += obj.model.name + '. ';
      }
      if (obj.dataLayer.offer_title) {
        ariaLabelString += obj.dataLayer.offer_title + '. ';
      }
      ariaLabelString += obj.dataLayer.offer_rate + '% APR. ';
      ariaLabelString += obj.dataLayer.offer_term + (isSpanish ? ' meses. ' : ' months. ');
      if (obj.extraCashAmount) {
        ariaLabelString += '$' + obj.extraCashAmount + ' ';
      }
      if (obj.extraCashLabel) {
        ariaLabelString += obj.extraCashLabel + '. ';
      }
      ariaLabelString += (isSpanish ? 'expira ' : 'expires ') + obj.dataLayer.offer_expired_date;
    } else if (obj.offerType === 'misc') {
      ariaLabelString += (isSpanish ? 'Miscellaneo TIPO DE OFERTA. ' : 'Miscellaneous offer type. ');
      if (obj.miscellaneous.label) {
        ariaLabelString += obj.miscellaneous.label + '. ';
      }
      if (obj.miscellaneous.title) {
        ariaLabelString += obj.miscellaneous.title + ' ';
      }
      if (obj.miscellaneous.description) {
        ariaLabelString += obj.miscellaneous.description + ' ';
      }
      ariaLabelString += (isSpanish ? 'expira ' : 'expires ') + obj.dataLayer.offer_expired_date;
    } else if (obj.offerType === 'msrp') {
      ariaLabelString += (isSpanish ? 'MSRP TIPO DE OFERTA. ' : 'MSRP offer type. ');
      if (obj.msrp.amount) {
        ariaLabelString += '$' + obj.msrp.amount + ' ';
      }
      if (obj.msrp.title) {
        ariaLabelString += obj.msrp.title + ' ';
      }
      if (obj.msrp.description) {
        ariaLabelString += obj.msrp.description + ' ';
      }
      ariaLabelString += (isSpanish ? 'expira ' : 'expires ') + obj.dataLayer.offer_expired_date;
    }
  }
  return ariaLabelString;
}
